import Mixin from './mixin.js'
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.mixin(Mixin)
    app.component('site-drawer', Component)
  }
}